import { lazy, Suspense } from 'react';

import { Routes } from 'react-router';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring';

import { RequireAuth, PageLoading } from './layout';

const Auth = lazy(async () => import('./auth'));
const Candidate = lazy(async () => import('./candidate'));

function App() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route path="auth">
          <Route index path="*" element={<Auth />} />
        </Route>
        <Route
          path="*"
          element={
            <RequireAuth resource="Candidate" role="employee">
              <Candidate />
            </RequireAuth>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default App;
